import { ECG_DISPLAY_OPTIONS } from '../';
export var getSampleGridHeight = function (configuration) {
    var blcksPerMV = configuration.AMPLITUDE * 100 * configuration.HEIGTH_AMPLITUDE_GIRD_RELATION;
    return blcksPerMV * configuration.BLOCK_SIZE;
};
export var getSampleWidthInSeconds = function (display) {
    var timeForSegmentInSeconds = display === ECG_DISPLAY_OPTIONS['4x2.5r'] ? 2.5 : 1;
    return timeForSegmentInSeconds;
};
export var getSampleGridWidth = function (display, configuration) {
    var timeForSegmentInSeconds = getSampleWidthInSeconds(display);
    var mmPerSegment = configuration.TIME * 100 * timeForSegmentInSeconds;
    return mmPerSegment * configuration.CELL_SIZE;
};
//# sourceMappingURL=getSampleSize.js.map